<div class="header">
    <h1>{{title}}</h1>
    <div class="spacer"></div>
    <ng-container *ngIf="isEditable">
        <btn *ngIf="!isEdit"
             type="actionMore"
             icon="fa-pen"
             (onClick)="edit()"></btn>
        <btn *ngIf="isEdit"
             type="actionPrincipal"
             icon="fa-check"
             (onClick)="edit()"></btn>
    </ng-container>
</div>
<div class="description" *ngIf="description">
    <label [innerHTML]="description"></label>
</div>
<notification type="error"
              *ngIf="errorNotification.active">
    {{errorNotification.message}}
</notification>
<loader *ngIf="loader" [message]="loaderMsg" type="large">

</loader>
<div *ngIf="displayAgency">
    <div class="content contentAgency" *ngIf="!loader">
        <div *ngIf="!isEdit; else editAgency">
            <div class="row">
                <label class="icon"></label>
                <label>{{formValue.name}}</label>
            </div>
            <div class="row">
                <label class="icon">
                    <fa-icon [icon]="iconLogo | iconNameToDefinition"></fa-icon>
                </label>
                <label *ngIf="formValue.logo; else notDefNes"></label>
                <img *ngIf="formValue.logo" [src]="formValue.logo" alt="logo" class="img" (click)="open()">
            </div>
            <div class="row">
                <label class="icon">
                    <fa-icon [icon]="iconMail | iconNameToDefinition"></fa-icon>
                </label>
                <label *ngIf="formValue.mail; else notDefNes"> {{formValue.mail}} </label>
            </div>
            <div class="row">
                <label class="icon">
                    <fa-icon [icon]="iconPhone | iconNameToDefinition"></fa-icon>
                </label>
                <label *ngIf="formValue.phone; else notDef"> {{formValue.phone}} </label>
            </div>
            <div class="row">
                <label class="icon">
                    <fa-icon [icon]="iconAddress | iconNameToDefinition"></fa-icon>
                </label>
                <label *ngIf="address; else notDef">{{address}}</label>
            </div>
        </div>
    </div>
</div>


<ng-template #editAgency>
    <div>
        <div class="rowLarge">
            <label class="icon"></label>
            <text class="input"
                  *ngIf="'name' | isEditableField:editableFields ; else nameNotEditable"
                  [fieldConfig]="config.nameConfig"
                  [isInternalError]="isInternalError"
                  (onBlur)="editAgencyEvent()"
                  (onKeyPress)="editAgencyEvent()">
            </text>
            <ng-template #nameNotEditable><label *ngIf="formValue.name">{{formValue.name}}</label></ng-template>
        </div>
        <div class="rowLarge">
            <label class="icon">
                <fa-icon [icon]="iconLogo | iconNameToDefinition"></fa-icon>
            </label>
            <input *ngIf="'logo' | isEditableField:editableFields"
                   class="input"
                   accept=".jpg,.jpeg,.png, .gif"
                   type="file"
                   (change)="upladImage($event)">
            <img *ngIf="formValue.logo" [src]="formValue.logo" alt="logo" class="img" (click)="open()">

        </div>
        <div class="rowLarge">
            <label class="icon">
                <fa-icon [icon]="iconMail | iconNameToDefinition"></fa-icon>
            </label>
            <text *ngIf="'mail' | isEditableField:editableFields ; else mailNotEditable"
                  class="input"
                  [fieldConfig]="config.mailConfig"
                  [isInternalError]="isInternalError"
                  (onBlur)="editAgencyEvent()"
                  (onKeyPress)="editAgencyEvent()">
            </text>
            <ng-template #mailNotEditable><label *ngIf="formValue.mail"> {{formValue.mail}} </label></ng-template>

        </div>
        <div class="rowLarge">
            <label class="icon">
                <fa-icon [icon]="iconPhone | iconNameToDefinition"></fa-icon>
            </label>
            <text *ngIf="'phone' | isEditableField:editableFields ; else phoneNotEditable"
                  class="input"
                  [fieldConfig]="config.phoneConfig"
                  [isInternalError]="isInternalError"
                  (onBlur)="editAgencyEvent()"
                  (onKeyPress)="editAgencyEvent()">
            </text>
            <ng-template #phoneNotEditable><label *ngIf="formValue.phone"> {{formValue.phone}} </label></ng-template>

        </div>
        <div class="rowLarge">
            <label class="icon">
                <fa-icon [icon]="iconAddress | iconNameToDefinition"></fa-icon>
            </label>
            <div class="contentAddress" *ngIf="'address' | isEditableField:editableFields ; else addressNotEditable">
                <div class="rowAddress">
                    <div class="rowAddress"
                         *ngFor="let configAddress of config.address.nameStreetConfig; let i = index">
                        <text class="inputAdd"
                              [fieldConfig]="configAddress"
                              [isInternalError]="isInternalError"
                              (onBlur)="editAgencyEvent()"
                              (onKeyPress)="editAgencyEvent()">
                        </text>
                        <btn *ngIf="i + 1 === config.address.nameStreetConfig.length && config.address.nameStreetConfig.length < 2"
                             type="actionPrincipal"
                             icon="fa-plus"
                             (onClick)="addAddLine(i + 1)"
                        ></btn>
                    </div>
                </div>
                <div class="rowAddress">
                    <text class="inputSmall"
                          [fieldConfig]="config.address.zipCodeConfig"
                          [isInternalError]="isInternalError"
                          (onBlur)="editAgencyEvent()"
                          (onKeyPress)="editAgencyEvent()">
                    </text>
                    <text class="input"
                          [fieldConfig]="config.address.cityConfig"
                          [isInternalError]="isInternalError"
                          (onBlur)="editAgencyEvent()"
                          (onKeyPress)="editAgencyEvent()">
                    </text>
                    <text class="input"
                          [fieldConfig]="config.address.countryConfig"
                          [isInternalError]="isInternalError"
                          (onBlur)="editAgencyEvent()"
                          (onKeyPress)="editAgencyEvent()">
                    </text>

                </div>
            </div>
            <ng-template #addressNotEditable>
                <div class="contentAddress">
                    <label *ngIf="address; else notDef">{{address}}</label>
                </div>
            </ng-template>

        </div>
    </div>
</ng-template>

<ng-template #notDef>
    <label class="notDef">{{wording.undefined}}</label>
</ng-template>

<ng-template #notDefNes>
    <label class="notDefNes">{{wording.undefined}}</label>
</ng-template>
